import React, { Component } from "react";
import "./RadioButton.css";

/**
 * @desc Radio button
 * @version 1.0.1
 * @author Praveen
 */
const ScoreRadio = props => {
  const selected = props.index === props.value ? true : false;
  if (selected) {
    return (
      <input
        type="radio"
        disabled={props.radioDisable}
        name={props.id}
        value={props.index}
        onClick={props.handleScoreChange}
        checked
      />
    );
  } else {
    return (
      <input
        type="radio"
        disabled={props.radioDisable}
        name={props.id}
        value={props.index}
        onClick={props.handleScoreChange}
      />
    );
  }
};

export default ScoreRadio;



// WEBPACK FOOTER //
// ./src/components/UI/RadioButton/RadioButton.js